import { DisplaySlot } from 'generated/graphql';
import { atom } from 'recoil';
import { broadcastChannelSynchronizerEffect } from 'utils/recoilEffects';

interface WorkspaceDisplayArrangement {
  displays: DisplaySlot[];
}
export const workspaceDisplayArrangementState = atom<WorkspaceDisplayArrangement | null>({
  key: 'workspaceDisplayArrangement',
  default: null,
  effects: [broadcastChannelSynchronizerEffect()],
});

export interface ActiveWorkspaceLayoutPreset {
  presetId: string;
  displayArrangementKey: string;
}

export const activeWorkspaceLayoutPresetState = atom<ActiveWorkspaceLayoutPreset | null>({
  key: 'activeWorkspaceLayoutPreset',
  default: null,
  effects: [broadcastChannelSynchronizerEffect()],
});
